import React from "react"
import { Container, Row, Col } from "reactstrap"
import pkg from "../../../package.json"

const Footer = () => {
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV
  const version = pkg.version

  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col sm={12}>
              © {new Date().getFullYear()} Ixora Technologies. All Rights
              Reserved.
              {env === "development" && (
                <span
                  style={{
                    marginLeft: "10px",
                    fontSize: "13px",
                    color: "gray",
                  }}
                >
                  Dev Mode | Version:{version}
                </span>
              )}
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
